import React from 'react'
import Citation from 'components/interactive/citation/citation'
// import Acronym from 'components/interactive/acronym'
import {Citations} from './expandables'
//-- image imports
import wallpaperImg from '../../images/prop-71.png'
import prevPropImg from '../../images/prop-70.png'
import nextPropImg from '../../images/prop-72.png'
// import {Link} from 'react-router-dom'

const PropExamplePageData = {
	pageId:"state-prop-71",
	meta: {
		canonicalUrl:"https://bythebay.cool/election/state-prop-71",
		documentTitle:"Proposition 71 • CA June 5 Election",
		socialHeadline:"Prop 71 closes a weird loophole",
		socialDescription:"It moves the date for when ballot measures become law.",
		socialImage:"https://s3-us-west-1.amazonaws.com/bythebay.cool/socialimages/howtopassalaw.png",
	},
	intro: {
		title: "Prop 71 is for loophole",
		subtitle:"Prop 71 closes a loophole for when a ballot measure goes into effect and when mail-in ballots are counted",
		img: wallpaperImg,
		color: 'pink' // see constants/colors.js for options
	},
	// -- [1,5]
	ratings: [
		{
			label:"complexity",
			rating: 1,
			explanation: "Prop 71 is pretty clear cut.",
		},
		{
			label:"funding",
			rating: 1,
			explanation:"Prop 71 was submitted by the state legislature so it didn't require additional funding to get it on the ballot.",
		},
		{
			label:"impact",
			rating: 1,
			explanation:"The measure closes a loophole that might have never occured.",
		},
		{
			label:"controversy",
			rating: 1,
			explanation:"This is uncontroversial. Prop 71 was legislatively referred by the State Assembly and Senate without opposition. The only opposition we could find was the offical argument submitted by Gary Wesley, who's stated mission is to submit arguments for unopposed ballot propositions.",
		},
		{
			label:"taxpayer cost",
			rating: 1,
			explanation:"Prop 71 would cost nothing to taxpayers.",
		},
	],
	sections: [
		{
			id: "010",
			type: "text-block", 
			data: {
				title: "A legal loophole, eh?",
				text: <div>
					Right now, our state constitutions says ballot measures approved by voters become law the "day after the election." Absentee mail-in ballots, however, are counted up to three days after the election, so it's possible mail-in ballots can decide the outcome of a proposition. <Citation data={Citations['3']}>This <em>almost</em> happened with the the plastic bag ban in Nov. 2016</Citation>.<br/><br/>
					Prop 71 closes the loophole by moving the date for when ballot propositions become law to <em>five days after</em> the Secretary of State confirms the electoral outcome.
					</div>,
			},
		},
		{
			id: "020", 
			type: "text-block", 
			data: {
				title: "Makes sense. Anything else?",
				text: <div>
					<Citation data={Citations['1']}>Yes, there's an attorney named Gary Wesley, who 40 years ago made it his mission to submit arguments against unchallenged propositions</Citation> <Citation data={Citations['2']}>, and the only argument against Prop 71 is the one he officially submitted</Citation>. The whole point of ballot initiatives, he says, is to empower the public to do something when the government won't, but Prop 71 empowers the Secretary of State to potentially delay a voter-approved initiative from being enacted for up to 38 days after an election.<br/><br/> He also claims Prop 71 is unnecessary since laws wouldn't take effect until all votes are counted anyway. CA's Constitution just says initiatives will be retroactive until the day after the election.
					<br/>
					<br/>
					The State Assembly and Senate disagree. They unanimously put Prop 71 on the ballot to eliminate ambiguity. <Citation data={Citations['4']}>To them it's a "minor, simple fix intended to clarify an existing law</Citation>."
					</div>,
			},
		},
		{
			id: "030",
			type: "links-block", 
			data: {
				subsections:[
					{
						subsectionTitle: "Supports Prop 71",
						links: [
							{
								text: "LA Times Editorial Board",
								url: "http://www.latimes.com/opinion/endorsements/la-ed-endorsement-prop-71-20180418-story.html"
							},
							{
								text: "SF Chronicle Editorial Board",
								url: "https://www.sfchronicle.com/opinion/editorials/article/Editorial-Chronicle-recommendations-on-Props-12849416.php"
							},
							{
								text: "Mercury News Editorial Board",
								url: "https://www.mercurynews.com/2018/03/15/editorial-prop-71/"
							},
							{
								text: "Sac Bee Editorial Board",
								url: "http://www.sacbee.com/opinion/editorials/article206202394.html"
							},
						],
					},
					{
						subsectionTitle: "More analysis",
						links: [
							{
								text: "Nonpartisan Legislative Analyst Office's summary",
								url:"http://voterguide.sos.ca.gov/propositions/71/analysis.htm"
							},
							{
								text: "CALmatters",
								url: "https://elections.calmatters.org/2018/california-ballot-measures/proposition-71-ballot-measure-effective-date/"
							},
							{
								text: "KALW",
								url: "http://kalw.org/post/california-prop-71-changing-start-date-ballot-initiatives#stream/0"
							},
						]
					},
				],
			}
		},
		{
			id: "080",
			type: "bottom-nav",
			data: {
				tiles: [
					{
						img: prevPropImg,
						to: "/election/state-prop-70",
						style: "",
						text: "Prop 70 is for politics",
					},
					{
						img: nextPropImg,
						to: "/election/state-prop-72",
						style: "",
						text: "Prop 72 is a tax exemption",
					}
				],
			}
		}
	]
}

export default PropExamplePageData;



// WEBPACK FOOTER //
// ./src/pages/june-5/props/data/71/data.js